import React from 'react'
import { Loader } from 'components'

function StaffLoading(): JSX.Element {
  const base = 'f-staff-loading'

  return (
    <tbody className={`${base}__list-body ${base}__list-body--empty`}>
      <tr>
        <td className={`${base}__cell-body-text`}>
          <Loader size='lg' />
        </td>
      </tr>
    </tbody>
  )
}

export default StaffLoading
